<template>
	<div class="flex max-h-9 items-center justify-between">
		<div class="flex items-center gap-3">
			<UserAvatar
				:diameter-px="36"
				user-name="Julia"
			/>

			<div class="flex flex-col justify-between">
				<span class="text-base text-won-dark-blue">
					{{ userName }}
				</span>
                
				<span
					class="mt-1 block text-[12px] leading-[14px] text-won-dark"
				>
					{{ userEmail }}
				</span>
			</div>
		</div>

		<div class="flex items-center gap-2">
			<AccessPreviewMenu
				v-model="userPermission"
				:options="options"
				:display-map="displayMap"
			/>

			<TrashIcon
				class="size-4 cursor-pointer text-won-ash-gray"
				@click="removeUserHandler"
			/>
		</div>
	</div>
</template>

<script setup>
import { toRefs, ref, watch } from 'vue';
import { TrashIcon } from '@heroicons/vue/24/outline';
import { useResumeShare } from '../../store/share-resume.store';

import UserAvatar from '../library/user-avatar.vue';
import AccessPreviewMenu from './access-preview-menu.vue';


const emit = defineEmits(['permission:update']);
const props = defineProps({
	userEmail: {
		type: String,
		default: null
	},
	userName: {
		type: String,
		required: true
	},
	permission: {
		type: String,
		default: null
	},
	userId: {
		type: Number,
		default: null
	},
	userRights: {
		type: Object,
		default: null
	},
	options: {
		type: Array,
		default() {
			return [];
		}
	},
	displayMap: {
		type: Object,
		default() {
			return {};
		}
	}
});
const { userName, userEmail, permission, userId } = toRefs(props);
const userPermission = ref(permission.value);

const resumeShareStore = useResumeShare();

const removeUserHandler = () => {
	resumeShareStore.setShowRemoveUserModal({
		userId: userId.value,
		email: userEmail.value
	});
};

watch(userPermission, (newPermission) => {
	emit('permission:update', newPermission);
});
</script>
